import { Autocomplete, AutocompleteChangeDetails, Box, Button, Grid, Modal, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import FixtureApi from './api/FixtureApi';
import BaseResponse from '../../app/BaseResponse';
import FixtureModel from './models/FixtureModel';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { FixtureInvoiceInputSelector, setAmount, setBankAccount, setBankReceived, setFixtureInvoiceInput, setForPeriodFrom, setForPeriodTo, setInvoiceNo, setIssDate, setPrivateCommSettled, setRcvDate, setSettledDate, setShowInvoiceInputPanel } from './reducers/FixtureInvoiceInputReducer';
import StartEndDatepicker from '../StartEndDatepicker/StartEndDatepicker';
import NumberFormatCustom from '../NumberFormatCustom/NumberFormatCustom';
import FixtureInvoiceInputModel from './models/FixtureInvoiceInputModel';
import { MarketInfoType } from '../MarketInfo/models/MarketInfoQueryModel';
import { CashAccountSelector, setCashAccounts } from '../Cash/reducers/CashAccountReducer';
import CashAccountApi from '../Cash/api/CashAccountApi';
import CashAccountModel from '../Cash/models/CashAccountModel';

const FixtureEditInvoice: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const fixtureInvoiceInputViewData = useSelector(FixtureInvoiceInputSelector);
    const cashModelData = useSelector(CashAccountSelector);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "60%",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        maxHeight: "calc(100% - 100px)",
        overflow: "auto"
    };

    useEffect(() => {
        if (fixtureInvoiceInputViewData.input.fixtureId.length > 0) {
            selectFixtureById(fixtureInvoiceInputViewData.input.fixtureId);
        }
    }, [fixtureInvoiceInputViewData.input.fixtureId])

    const selectFixtureById = (id: string) => {
        dispatch(showLoading(true));
        FixtureApi.GetById({
            id: id
        }).then((response: BaseResponse<FixtureModel>) => {
            if (response.success) {
                let fixtureInput = Utility.CloneObject(response.data) as FixtureInvoiceInputModel;
                fixtureInput.fixtureId = response.data.id;

                dispatch(setFixtureInvoiceInput(fixtureInput));

                dispatch(showLoading(false));

            } else {
                Utility.Alert.Error(response.message);
                dispatch(showLoading(false));
            }
        }).catch((error) => {
            Utility.Alert.Error(error);
            dispatch(showLoading(false));
        })
    };

    const save = () => {
        try {
            dispatch(showLoading(true));

            FixtureApi.SaveInvoice(fixtureInvoiceInputViewData.input)
                .then((response: BaseResponse<FixtureModel>) => {
                    if (response.success) {
                        Utility.Alert.Success("Fixture invoice updated successful");

                        dispatch(showLoading(false));

                        dispatch(setShowInvoiceInputPanel(true));
                    }
                    else {
                        dispatch(showLoading(false));
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    dispatch(showLoading(false));
                    Utility.Alert.Error(error);
                });
        } catch (error) {
            dispatch(showLoading(false));
            Utility.Alert.Error(error);
        }
    }

    return (
        <>
            <Modal
                open={fixtureInvoiceInputViewData.showInvoiceInputPanel}
                onClose={() => {
                    dispatch(setShowInvoiceInputPanel(false));
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <h1>Update Invoice</h1>
                    <br />
                    <Grid container>
                        <Grid item lg={6} xs={12}>
                            <TextField
                                label="Invoice No"
                                fullWidth
                                value={fixtureInvoiceInputViewData.input.invoiceNo}
                                onChange={(event) => {
                                    dispatch(setInvoiceNo(event.target.value));
                                }}
                                className='cargo-input-component'
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <StartEndDatepicker
                                startDateLabel="Invoice Date"
                                className="cargo-input-component"
                                useSingleMode={true}
                                useQuickEndDateInput={false}
                                onStartDateChange={(date: string) => {
                                    dispatch(setIssDate(date));
                                }}
                                startDateValue={Utility.DateFormat.formatDateString(fixtureInvoiceInputViewData.input.issDate ? fixtureInvoiceInputViewData.input.issDate.toUpperCase() : "")}
                                allowFreeInput={true}
                            >
                            </StartEndDatepicker>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item lg={6} xs={12}>
                            <TextField
                                fullWidth
                                className="cargo-input-component"
                                label="Amount"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={fixtureInvoiceInputViewData.input.amount ? fixtureInvoiceInputViewData.input.amount : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setAmount(value));
                                }}
                            >
                            </TextField>
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <StartEndDatepicker
                                startDateLabel="Received Date"
                                className="cargo-input-component"
                                useSingleMode={true}
                                useQuickEndDateInput={false}
                                onStartDateChange={(date: string) => {
                                    dispatch(setRcvDate(date));
                                }}
                                startDateValue={Utility.DateFormat.formatDateString(fixtureInvoiceInputViewData.input.rcvDate ? fixtureInvoiceInputViewData.input.rcvDate.toUpperCase() : "")}
                                allowFreeInput={true}
                            >
                            </StartEndDatepicker>
                        </Grid>
                    </Grid>
                    {/* {
                        (fixtureInvoiceInputViewData.input.bizType == MarketInfoType.TCT || fixtureInvoiceInputViewData.input.bizType == MarketInfoType.TC) &&
                        <>
                            <Grid container>
                                <Grid item lg={6} xs={12}>
                                    <StartEndDatepicker
                                        startDateLabel="Period from"
                                        className="cargo-input-component"
                                        useSingleMode={true}
                                        useQuickEndDateInput={false}
                                        onStartDateChange={(date: string) => {
                                            dispatch(setForPeriodFrom(date));
                                        }}
                                        startDateValue={Utility.DateFormat.formatDateString(fixtureInvoiceInputViewData.input.forPeriodFrom ? fixtureInvoiceInputViewData.input.forPeriodFrom.toUpperCase() : "")}
                                        allowFreeInput={true}
                                    >
                                    </StartEndDatepicker>
                                </Grid>
                                <Grid item lg={6} xs={12}>
                                    <StartEndDatepicker
                                        startDateLabel="Period to"
                                        className="cargo-input-component"
                                        useSingleMode={true}
                                        useQuickEndDateInput={false}
                                        onStartDateChange={(date: string) => {
                                            dispatch(setForPeriodTo(date));
                                        }}
                                        startDateValue={Utility.DateFormat.formatDateString(fixtureInvoiceInputViewData.input.forPeriodTo ? fixtureInvoiceInputViewData.input.forPeriodTo.toUpperCase() : "")}
                                        allowFreeInput={true}
                                    >
                                    </StartEndDatepicker>
                                </Grid>
                            </Grid>
                        </>
                    } */}
                    <Grid container>
                        <Grid item lg={6} xs={12}>
                            <Autocomplete
                                className='cargo-input-component'
                                options={_.map(cashModelData.cashAccounts, (cashAccount) => { return cashAccount.account; })}
                                renderInput={(params) => <TextField {...params} label="Account" />}
                                value={fixtureInvoiceInputViewData.input.bankAccount}
                                onChange={(event: React.SyntheticEvent, value: string | null, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                    dispatch(setBankAccount(value ? value : ""));
                                }}
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <TextField
                                label="Bank Received"
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={fixtureInvoiceInputViewData.input.bankReceived ? fixtureInvoiceInputViewData.input.bankReceived : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setBankReceived(value));
                                }}
                                className='cargo-input-component'
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item lg={6} xs={12}>
                            <TextField
                                label="Private Comm Settled"
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                }}
                                value={fixtureInvoiceInputViewData.input.privateCommSettled ? fixtureInvoiceInputViewData.input.privateCommSettled : ""}
                                onChange={(event) => {
                                    let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                                    dispatch(setPrivateCommSettled(value));
                                }}
                                className='cargo-input-component'
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <StartEndDatepicker
                                startDateLabel="Settled Date"
                                className="cargo-input-component"
                                useSingleMode={true}
                                useQuickEndDateInput={false}
                                onStartDateChange={(date: string) => {
                                    dispatch(setSettledDate(date));
                                }}
                                startDateValue={Utility.DateFormat.formatDateString(fixtureInvoiceInputViewData.input.settledDate ? fixtureInvoiceInputViewData.input.settledDate.toUpperCase() : "")}
                                allowFreeInput={true}
                            >
                            </StartEndDatepicker>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item lg={6} xs={12}>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    save();
                                }}
                            >Save</Button>
                        </Grid>
                        <Grid item lg={6} xs={12}>

                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
};

export default FixtureEditInvoice;